import React from 'react';
import { Modal } from 'react-responsive-modal';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { HorizontalCenterWrapper } from '../../v3Styles';
import {
  CartCheckoutButton,
  EmojiBullet,
  PicsPlusAnnualSubBox,
  PicsPlusContainer,
  PicsPlusHeader,
  PicsPlusHeader2,
  PicsPlusListItem,
  PicsPlusListItemHeader,
  PicsPlusText,
} from './picsPlusModalStyles';

const PicsPlusMemberModal = ({ open, onClose, subscriptionInfo }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeIcon={
        <XMarkIcon
          style={{
            width: '28px',
            height: '28px',
            color: '#999',
            cursor: 'pointer',
          }}
        />
      }
      classNames={{
        root: 'modal-root',
        overlay: 'overlay',
        modal: 'pics-plus-member-modal',
      }}
      center={false}
      styles={{
        overlay: {
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          padding: '0',
        },
        modal: {
          margin: '0 auto',
          marginTop: 0,
          padding: 0,
          maxHeight: '100vh',
          overflowY: 'auto',
          width: '100%',
          maxWidth: '600px',
          position: 'relative',
          top: 0,
          transform: 'none',
        },
      }}
    >
      <PicsPlusContainer>
        <PicsPlusHeader>✨ Pics+</PicsPlusHeader>
        <PicsPlusHeader2 style={{ fontWeight: 700 }}>
          Your Membership
        </PicsPlusHeader2>

        <ul style={{ listStyle: 'none', padding: 0, margin: '24px 0' }}>
          <PicsPlusListItem>
            <EmojiBullet>✅</EmojiBullet>
            <div>
              <PicsPlusListItemHeader style={{ color: '#FF6B9D' }}>
                No service fee on this order
              </PicsPlusListItemHeader>
              <PicsPlusText>
                You're saving money right now! This benefit applies to every
                order you place.
              </PicsPlusText>
            </div>
          </PicsPlusListItem>
          <PicsPlusListItem>
            <EmojiBullet>📸</EmojiBullet>
            <div>
              <PicsPlusListItemHeader>
                Your memories, saved forever
              </PicsPlusListItemHeader>
              <PicsPlusText>
                No expiration dates. Your photos stay safe and accessible for
                life.
              </PicsPlusText>
            </div>
          </PicsPlusListItem>
          <PicsPlusListItem>
            <EmojiBullet>🏠</EmojiBullet>
            <div>
              <PicsPlusListItemHeader>
                Family-wide coverage
              </PicsPlusListItemHeader>
              <PicsPlusText>
                One membership covers everyone in your household - all the kids,
                all the photos.
              </PicsPlusText>
            </div>
          </PicsPlusListItem>
          <PicsPlusListItem>
            <EmojiBullet>🎁</EmojiBullet>
            <div>
              <PicsPlusListItemHeader>
                Exclusive member perks
              </PicsPlusListItemHeader>
              <PicsPlusText>
                Early access to new products, special offers, and surprise
                member treats.
              </PicsPlusText>
            </div>
          </PicsPlusListItem>
          <PicsPlusListItem>
            <EmojiBullet>💚</EmojiBullet>
            <div>
              <PicsPlusListItemHeader>
                Supporting families in need
              </PicsPlusListItemHeader>
              <PicsPlusText>
                Your membership helps provide scholarships for children to enjoy
                their school portrait experience.
              </PicsPlusText>
            </div>
          </PicsPlusListItem>
        </ul>

        <PicsPlusAnnualSubBox>
          <PicsPlusHeader2
            style={{ fontSize: '16px', fontWeight: 600, margin: 0 }}
          >
            Membership Status: Active ✓
          </PicsPlusHeader2>
          {subscriptionInfo?.member_since && (
            <PicsPlusText style={{ marginTop: '8px', marginBottom: '4px' }}>
              Member since: {subscriptionInfo.member_since}
            </PicsPlusText>
          )}
          {subscriptionInfo?.in_trial && subscriptionInfo?.trial_ends && (
            <PicsPlusText
              style={{ color: '#FF6B9D', fontWeight: 600, margin: 0 }}
            >
              Free trial until: {subscriptionInfo.trial_ends}
            </PicsPlusText>
          )}
          {!subscriptionInfo?.in_trial && subscriptionInfo?.next_billing && (
            <PicsPlusText
              style={{ color: '#FF6B9D', fontWeight: 600, margin: 0 }}
            >
              Next billing: {subscriptionInfo.next_billing}
            </PicsPlusText>
          )}
        </PicsPlusAnnualSubBox>

        <CartCheckoutButton onClick={onClose} id="member-modal-close">
          Got it, thanks!
        </CartCheckoutButton>
      </PicsPlusContainer>
    </Modal>
  );
};

export default PicsPlusMemberModal;
